export const toggleSidebar = () => {
  document.body.classList.toggle("withoutBar");
  document.body.classList.toggle("sidebar-test-close");
  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });
};
